'use client'

import { useEffect, type RefObject } from 'react'

import type { HubVisit } from '@/lib/analytics/hub-visit'

import { trackHubLink } from './hub-analytics'
import { hubLayoutTracking } from './hub-layout-tracking'
import { observeHubSections } from './observe-hub-sections'
import { observeHubVisit } from './observe-hub-visit'

export const useHubAnalytics = (ref: RefObject<HTMLDivElement | null>, visit: HubVisit) => {
  useEffect(() => {
    const root = ref.current
    if (!root) {
      return
    }
    const layout = hubLayoutTracking(root)
    visit.setLayoutTracking(layout)
    const properties = { hubVisitId: visit.id, ...layout }
    const stopSections = observeHubSections(root, visit.sectionViewed, properties)
    const stopVisit = observeHubVisit(root, visit)
    const click = (event: MouseEvent) => trackHubLink(event, properties)
    root.addEventListener('click', click)
    root.addEventListener('auxclick', click)
    return () => {
      stopVisit()
      stopSections()
      root.removeEventListener('click', click)
      root.removeEventListener('auxclick', click)
    }
  }, [ref, visit])
}
